"use strict";

var _interopRequireWildcard = require("@babel/runtime-corejs3/helpers/interopRequireWildcard");

var _interopRequireDefault = require("@babel/runtime-corejs3/helpers/interopRequireDefault");

var _Object$defineProperty = require("@babel/runtime-corejs3/core-js/object/define-property");

_Object$defineProperty(exports, "__esModule", {
  value: true
});

exports.ConnectedAuthenticatedContent = exports.AuthenticatedContent = void 0;

var _objectSpread2 = _interopRequireDefault(require("@babel/runtime-corejs3/helpers/objectSpread2"));

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime-corejs3/helpers/classCallCheck"));

var _createClass2 = _interopRequireDefault(require("@babel/runtime-corejs3/helpers/createClass"));

var _inherits2 = _interopRequireDefault(require("@babel/runtime-corejs3/helpers/inherits"));

var _createSuper2 = _interopRequireDefault(require("@babel/runtime-corejs3/helpers/createSuper"));

var _jsxRuntime = require("react/jsx-runtime");

var _react = require("@fluentui/react");

var _Button = require("@fluentui/react/lib/Button");

var _Utilities = require("@fluentui/react/lib/Utilities");

var React = _interopRequireWildcard(require("react"));

var _reactI18next = require("react-i18next");

var _reactRedux = require("react-redux");

var _AppSuite = require("../../AppSuite");

var _i18n = _interopRequireDefault(require("../../i18n"));

var _createAction = require("../../redux/createAction");

var _stylingConstants = require("../../styling/stylingConstants");

var _ellipsis = require("../../text/ellipsis");

var _UserActions = require("../../User/models/UserActions");

var _Loading = require("../Loading");

var _isAppDisabled = require("../shared/isAppDisabled");

var _SignInDialog = require("./SignInDialog");

var _SignoutDialog = require("./SignoutDialog");

var styles = require('../../styling/patterns/App.scoped.scss');

var isAuthenticating = false;
var isVerifyingAuthorization = false;
/**
 * The AuthenticatedContent control prevents content from being rendered until the user is authenticated.
 * Instead it dislays a loading UX.
 */

var AuthenticatedContent = /*#__PURE__*/function (_React$Component) {
  (0, _inherits2.default)(AuthenticatedContent, _React$Component);

  var _super = (0, _createSuper2.default)(AuthenticatedContent);

  function AuthenticatedContent() {
    (0, _classCallCheck2.default)(this, AuthenticatedContent);
    return _super.apply(this, arguments);
  }

  (0, _createClass2.default)(AuthenticatedContent, [{
    key: "render",
    value: function render() {
      var t = this.props.t;
      var content = this.props.children;
      var hasAuthenticated = this.props.hasAuthenticated;
      var hasError = this.props.hasError;
      var autoLoginDisabled = this.props.autoLoginDisabled;

      if (process.env.APP_SUITE_ENABLED === 'true' && !!process.env.APP_SUITE_APP_KEY && this.props.isAppDisabled) {
        return /*#__PURE__*/(0, _jsxRuntime.jsx)(_react.MessageBar, {
          "data-automation-id": "not-authorized",
          messageBarType: _react.MessageBarType.warning,
          isMultiline: true,
          styles: {
            root: {
              borderRadius: _stylingConstants.gridUnit,
              margin: _stylingConstants.gridUnit * 2,
              width: '98vw;'
            }
          },
          actions: /*#__PURE__*/(0, _jsxRuntime.jsxs)("div", {
            children: [this.props.continueUrl ? /*#__PURE__*/(0, _jsxRuntime.jsx)(_Button.MessageBarButton, {
              href: this.props.continueUrl,
              title: this.props.continueLabel,
              children: this.props.continueLabel ? this.props.continueLabel : t('Continue')
            }) : null, this.props.signOutVisible !== false ? /*#__PURE__*/(0, _jsxRuntime.jsx)(_Button.MessageBarButton, {
              onClick: this.props.logout,
              children: this.props.signOutButtonText || t('Sign out')
            }) : null]
          }),
          children: this.props.notAuthorizedMessage
        });
      }

      if (!hasAuthenticated) {
        content = null;

        if (autoLoginDisabled) {
          return this._renderLoginDialog();
        }
      } else if (hasError) {
        return this._renderSignOutDialog();
      }

      return /*#__PURE__*/(0, _jsxRuntime.jsx)("div", {
        className: (0, _Utilities.css)('ms-App', styles.app),
        children: content
      });
    }
  }, {
    key: "componentWillMount",
    value: function componentWillMount() {
      this.checkAuth();
    }
  }, {
    key: "componentWillReceiveProps",
    value: function componentWillReceiveProps() {
      this.checkAuth();
    }
  }, {
    key: "checkAuth",
    value: function checkAuth() {
      if (isAuthenticating && this.props.hasAuthenticated) {
        isAuthenticating = false;

        this._refreshLanguage();
      }

      if (!this.props.hasAuthenticated && !isAuthenticating && !this.props.autoLoginDisabled) {
        // Do not start a login while a log in is in progress
        isAuthenticating = true;
        this.props.login();
      }

      if (process.env.APP_SUITE_ENABLED === 'true' && !!process.env.APP_SUITE_APP_KEY && this.props.hasAuthenticated && !isVerifyingAuthorization) {
        isVerifyingAuthorization = true;
        this.props.getAppsEnabled();
      }
    }
  }, {
    key: "_renderLoginDialog",
    value: function _renderLoginDialog() {
      var content = null;
      var popupEnabled = this.props.popupEnabled;
      var titleText = this.props.t('Sign in');
      var subTitle = this.props.t("Please click on SignIn button to continue".concat(_ellipsis.ellipsis)); // If popup enabled override the default instructional text.

      if (popupEnabled) {
        subTitle = this.props.t('If sign-in popup doesn\'t open upon clicking sign in, please disable the popup blocker for this URL and refresh the browser.');
      }

      content = /*#__PURE__*/(0, _jsxRuntime.jsx)(_SignInDialog.SignInDialog, {
        t: this.props.t,
        dialogContentProps: {
          title: titleText,
          subText: subTitle
        },
        login: this.props.login
      });
      return content;
    }
  }, {
    key: "_renderSignOutDialog",
    value: function _renderSignOutDialog() {
      var content = null;
      var loginError = this.props.user.auth.loginError;
      var popupEnabled = this.props.popupEnabled;
      var errorText = this.props.t("Sorry, we can't sign you in");
      var errorDetails = this.props.t('Please ensure that cookies are enabled and sign out to try again'); // If popup enabled override the default message based on error.

      if (popupEnabled) {
        var popupErrorDetails = this.props.t('We ran into a problem because your browser does not allow pop-ups. ' + 'Please allow pop-ups in your browser settings and sign out to try again');

        if (loginError === 'Popup Window is null. This can happen if you are using IE' || loginError === 'Popup Window closed by UI action/ Popup Window handle destroyed due to cross zone navigation in IE/Edge') {
          errorDetails = popupErrorDetails;
        }
      }

      content = /*#__PURE__*/(0, _jsxRuntime.jsx)(_SignoutDialog.SignoutDialog, {
        t: this.props.t,
        dialogContentProps: {
          title: errorText,
          subText: errorDetails
        },
        logout: this.props.logout
      });
      return content;
    }
  }, {
    key: "_refreshLanguage",
    value: function _refreshLanguage() {
      _i18n.default.changeLanguage('');
    }
  }]);
  return AuthenticatedContent;
}(React.Component);
/**
 * Maps the external (i.e. own) props and the state to the properties of the AuthenticatedContent control.
 * @param state The current redux state to map to props
 * @param ownProps The external properties to map to props
 * @returns The mapped properties that along with the actions
 * becomes the props (IAuthenticatedContentProps) for the AuthenticatedContent control
 */


exports.AuthenticatedContent = AuthenticatedContent;

var mapStateToProps = function mapStateToProps() {
  var location = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : window.location;
  return function (state, props) {
    var hasError = !!state.user.auth.loginError;
    var enabledAuthorization = process.env.APP_SUITE_ENABLED === 'true';
    return (0, _objectSpread2.default)((0, _objectSpread2.default)((0, _objectSpread2.default)({}, props), {}, {
      hasAuthenticated: !state.user.isLoading || hasError,
      autoLoginDisabled: process.env.APP_ADAL_DISABLE_AUTO_LOGIN === 'true',
      popupEnabled: process.env.APP_ADAL_LOGIN_POPUP === 'true',
      user: state.user
    }, (0, _Loading.getLoadingState)(state.user, enabledAuthorization ? state.appSuite.enabledApps : null, state.user.flights)), {}, {
      isAppDisabled: process.env.APP_SUITE_ENABLED === 'true' && (0, _isAppDisabled.isAppDisabled)(props, state.appSuite),
      hasError: hasError
    });
  };
};
/**
 * Maps the dispatch actions to the props for the AuthenticatedContent control.
 * @param dispatch Dispatches actions to the store
 * @returns The mapped actions that along with the mapped properties
 * becomes the props (IAuthenticatedContentProps) for the AuthenticatedContent control
 */


var mapDispatchToProps = function mapDispatchToProps(dispatch) {
  return {
    login: (0, _createAction.createAction)(_UserActions.UserActions.getMyUserRequest, dispatch),
    logout: (0, _createAction.createAction)(_UserActions.UserActions.logOut, dispatch),
    getAppsEnabled: (0, _createAction.createAction)(_AppSuite.AppSuiteActions.getAppsEnabled, dispatch)
  };
};
/**
 * A redux connected AuthenticatedContent control.
 */


var ConnectedAuthenticatedContent = (0, _reactRedux.connect)(mapStateToProps(), mapDispatchToProps, undefined, {
  pure: false
} // Container control
)((0, _reactI18next.translate)('App')(AuthenticatedContent));
exports.ConnectedAuthenticatedContent = ConnectedAuthenticatedContent;